import { usePlaySound, btnDelay } from "common/utils";
import i18n from "features/parent/i18n";
import { AIChatSession } from "features/parent/types";
import { AIChatSessionCard } from "./AIChatSessionCard";

interface AIChatHistorySectionProps {
  sessions: AIChatSession[];
  onShowMore: () => void;
  onSelectSession: (session: AIChatSession) => void;
}

export const AIChatHistorySection = ({
  sessions,
  onShowMore,
  onSelectSession,
}: AIChatHistorySectionProps) => {
  const play = usePlaySound();

  const handleShowMore = () => {
    play();
    btnDelay(() => onShowMore());
  };

  const handleSelectSession = (session: AIChatSession) => {
    play();
    btnDelay(() => onSelectSession(session));
  };

  return (
    <div className="bg-white rounded-[16px] p-6">
      {/* ヘッダー */}
      <div className="flex-row-el items-center justify-between mb-5 pb-3 border-b border-outline">
        <div className="flex-row-el items-center gap-2 text-[24px] text-textcolor-black">
          <span className="material-symbols-outlined !text-[45px] text-red-100">smart_toy</span>
          {i18n.t("MSG_PARENT_PAGE_AI_CHAT_HISTORY")}
          <span className="text-[21px] font-normal text-gray2-100 ml-1">({sessions.length})</span>
        </div>

        {/* もっと見るボタン（4件以上の場合） */}
        {sessions.length > 3 && (
          <button
            className="flex-row-el items-center gap-1 px-4 py-2 bg-transparent border-2 border-red-100 rounded-[12px] text-[21px] text-red-100 cursor-pointer hover:bg-red-100/10 transition-all"
            onClick={handleShowMore}
          >
            {i18n.t("MSG_PARENT_PAGE_PLAYER_SHOW_MORE")}
            <span className="material-symbols-outlined text-[24px]">chevron_right</span>
          </button>
        )}
      </div>

      {/* セッションカード表示（最大3件、スクロールなし） */}
      {sessions.length > 0 ? (
        <div className="flex-col-el gap-3">
          {sessions.slice(0, 3).map((session) => (
            <AIChatSessionCard
              key={session.id}
              session={session}
              onClick={() => handleSelectSession(session)}
            />
          ))}
        </div>
      ) : (
        <div className="flex-col-center py-8 text-gray2-100">
          <span className="material-symbols-outlined text-[60px] mb-2">smart_toy</span>
          <span className="text-[21px]">{i18n.t("MSG_PARENT_PAGE_AI_CHAT_HISTORY_EMPTY")}</span>
        </div>
      )}
    </div>
  );
};
